import { Button } from '@zenterprise-inc/ui';
import { ReactNode } from 'react';

interface CTAProps {
  children: ReactNode;
  onClick?: () => void;
  type?: HTMLButtonElement['type'];
  disabled: boolean;
  state?: 'primary' | 'basic' | 'secondary' | 'warning';
}

export const CTA = ({ children, onClick, type, disabled, state = 'primary' }: CTAProps) => {
  return (
    <Button.StickyBottom.Wrapper className={'px-4.5'}>
      <Button.StickyBottom.Button disabled={disabled} type={type ?? 'button'} state={state} onClick={onClick}>
        {children}
      </Button.StickyBottom.Button>
    </Button.StickyBottom.Wrapper>
  );
};
